module.exports = __webpack_public_path__ + "img/header-weddingRingsBestseller@2x.a3da068.jpg";